import script from "./PageTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageTitle.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__